const data = {
  pageName: "Settings",
  myAccountLegacyBaseUrl: "/api/",

  services: {
    settingsData: {
      url: "settings/data",
      params: {}
    }
  }
};

exports.data = data;
